<div class="modal-container">
  <div class="modal-header">
    <h2 mat-dialog-title>Session Details</h2>
    <div class="modal-subtitle">{{data.storeId}} ({{data.deviceId}}) - {{data.formattedDate}}</div>
    <button class="close-btn" (click)="close()">&times;</button>
  </div>

  <mat-dialog-content>
    <div class="loading-shade" *ngIf="isLoading">
      <div class="spinner"></div>
    </div>

    <table class="session-table" *ngIf="!isLoading">
      <thead>
        <tr>
          <th (click)="sortBy('Timestamp')" style="cursor: pointer;">
            Time <span *ngIf="sortColumn === 'Timestamp'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th (click)="sortBy('sessionId')" style="cursor: pointer;">
            Session ID <span *ngIf="sortColumn === 'sessionId'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th *ngIf="!data.isKonoboxBrand" (click)="sortBy('CutStyle')" style="cursor: pointer;">
            Print Cut <span *ngIf="sortColumn === 'CutStyle'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th *ngIf="!data.isKonoboxBrand" (click)="sortBy('FrameId')" style="cursor: pointer;">
            Frame <span *ngIf="sortColumn === 'FrameId'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th *ngIf="data.isKonoboxBrand" (click)="sortBy('songCount')" style="cursor: pointer;">
            Songs <span *ngIf="sortColumn === 'songCount'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th (click)="sortBy('PaymentMethod')" style="cursor: pointer;">
            Payment <span *ngIf="sortColumn === 'PaymentMethod'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th (click)="sortBy('AmountPaid')" style="cursor: pointer;">
            Amount <span *ngIf="sortColumn === 'AmountPaid'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th (click)="sortBy('OverpaidAmount')" style="cursor: pointer;">
            Overpaid <span *ngIf="sortColumn === 'OverpaidAmount'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th *ngIf="!data.isKonoboxBrand" (click)="sortBy('Animefied')" style="cursor: pointer;">
            Animefied <span *ngIf="sortColumn === 'Animefied'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th *ngIf="!data.isKonoboxBrand">Action</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let session of sessions">
          <tr class="element-row">
          <td>{{ session.Timestamp ? ((session.Timestamp.seconds * 1000) | date:'shortTime') : 'N/A' }}</td>
          <td class="mono" [title]="session.sessionId" style="cursor: pointer;" (click)="copySessionId(session.sessionId)">
            {{ session.sessionId | slice:0:6 }}
          </td>
          <td *ngIf="!data.isKonoboxBrand">{{ session.CutStyle || 'N/A' }}</td>
          <td *ngIf="!data.isKonoboxBrand">
            <a href="javascript:void(0)" (click)="toggleRow(session); $event.stopPropagation()" class="frame-link" [title]="session.FrameId || session.ThemeFrameGroupId || 'N/A'">
              {{ session.FrameId || session.ThemeFrameGroupId || 'N/A' }}
            </a>
          </td>
          <td *ngIf="data.isKonoboxBrand">
            <span class="badge" *ngIf="session.songCount">{{ session.songCount }} Song{{ session.songCount > 1 ? 's' : '' }}</span>
            <span *ngIf="!session.songCount">-</span>
          </td>
          <td>{{ session.PaymentMethod || 'Unknown' }}</td>
          <td>{{ session.AmountPaid | currency }}</td>
          <td>{{ (session.OverpaidAmount || 0) | currency }}</td>
          <td *ngIf="!data.isKonoboxBrand">
            <span *ngIf="session.AnimefiedGenerated || session.AnimefiedUsed" class="badge">
              Gen: {{session.AnimefiedGenerated || 0}} / Used: {{session.AnimefiedUsed || 0}}
            </span>
            <span *ngIf="!session.AnimefiedGenerated && !session.AnimefiedUsed" style="color:#aaa">-</span>
          </td>
          <td *ngIf="!data.isKonoboxBrand">
            <a [href]="getClaimUrl(session.sessionId)" target="_blank" class="claim-link">View Session</a>
          </td>
        </tr>
        
        <!-- Expanded Frame Detail Row (Photobooth only) -->
        <tr class="detail-row" *ngIf="!data.isKonoboxBrand && expandedSession === session">
          <td colspan="9" class="detail-cell">
            <div class="frame-detail-content">
              <div class="frame-loading" *ngIf="session.isLoadingFrame">
                <div class="spinner"></div>
              </div>
              <div class="frame-info" *ngIf="!session.isLoadingFrame">
                <div class="frame-text-info">
                  <div class="detail-group">
                    <span class="detail-label">Theme</span>
                    <span class="detail-value">{{ session.Theme || 'N/A' }}</span>
                  </div>
                  <div class="detail-group">
                    <span class="detail-label">Group ID</span>
                    <span class="detail-value">{{ session.ThemeFrameGroupId || 'N/A' }}</span>
                  </div>
                </div>
                <div class="frame-image-wrapper">
                  <a *ngIf="session.frameImageUrl" [href]="session.frameImageUrl" target="_blank" download class="download-link" title="Click to download">
                    <img [src]="session.frameImageUrl" alt="Frame" class="frame-preview-img" />
                  </a>
                  <div *ngIf="!session.frameImageUrl && !session.isLoadingFrame" class="no-image">No Image Available</div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </ng-container>
        
        <tr *ngIf="sessions.length === 0">
          <td [attr.colspan]="data.isKonoboxBrand ? 6 : 9" class="empty-state">No sessions found for this date.</td>
        </tr>
      </tbody>
    </table>
  </mat-dialog-content>
</div>
